module.exports = __webpack_public_path__ + "static/media/1007155.3ea61dc0.jpg";